import React, { useEffect, useState, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import MaterialTable from '../../shared/components/material-table';
import columns from './components/Columns';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import GraphQL from '../../GraphQL';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import { classDiaryListBySmartFilter } from '../../shared/queries/ClassDiary';
import FullScreenDialog from '../../shared/components/FullScreenDialog';
import AttendanceStudentFormHandler from './components/AttendanceStudentFormHandler';

const ClassDiary = (props) => {
  const [data, setData] = useState([]);
  const { t, history, dispatch } = props;
  const [openScreen, setOpenScreen] = useState(false);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleFullScreen = () => {
    setOpenScreen(!openScreen);
  };

  const addItemClickHandler = () => {
    history.push('/minime/diario-classe/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/diario-classe/mnt/${rowData.id}`);
  };

  const loadData = () => {
    showLoading();
    const filter = { id: 0 };
    const query = classDiaryListBySmartFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.classDiaryListBySmartFilter = res.classDiaryListBySmartFilter.map(
          (classDiary) => ({
            ...classDiary,
            formattedDate: format(
              new Date(classDiary.dateInMilli),
              'dd/MM/yyyy'
            ),
            classes: classDiary.classSequence.join(','),
          })
        );
        setData(res.classDiaryListBySmartFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <FullScreenDialog
        title={t('general.presence-grid')}
        toggleDialog={toggleFullScreen}
        isOpen={openScreen}
        toggleBackDialog={toggleFullScreen}
      >
        <AttendanceStudentFormHandler toggleFullScreen={toggleFullScreen} />
      </FullScreenDialog>
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    title={t('panels.class-diary')}
                    data={data}
                    columns={columns(t)}
                    onRefreshClick={loadData}
                    pageSize={DEFAULT_PAGE_SIZE}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onAppClick={{
                      tooltip: t('general.tables.view-presence-grid'),
                      callback: toggleFullScreen,
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

ClassDiary.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ClassDiary)
);
